import { ListType } from "../BandingEthnicityForm/Types";

export enum DateOperator {
  On,
  NotOn,
  After,
  AfterOrOn,
  Before,
  BeforeOrOn,
  value
}

export enum DateType {
  DateParameter,
  RelativeDate,
}

export enum DateParameterType {
  Today,
  Now,
  FixedDate,
  Predefined,
  Rule,
  searchDate
}

export enum TimePeriod {
  Year,
  Month,
  Week,
  Day,
  Hour,
  Minute,
}

export enum BeforeAfter {
  Before,
  After,
}

export interface DateOffset {
  time?: number;
  timePeriod?: TimePeriod;
  beforeAfter?: BeforeAfter;
}

export interface DateParameter {
  type: DateType.DateParameter;
  dateParameterType: DateParameterType;
  fixedDate?: Date;
  dateOffset?: DateOffset;
  userDefinedDate?: string;
}

export enum ThisLastNext {
  This,
  Last,
  Next,
}

export const thisLastNextText = {
  [ThisLastNext.This]: "this",
  [ThisLastNext.Last]: "last",
  [ThisLastNext.Next]: "next",
};

export enum RelativePeriod {
  Week,
  Month,
  Quarter,
  Year,
  FiscalYear,
}

export interface RelativeDate {
  type: DateType.RelativeDate;
  thisLastNext?: ThisLastNext;
  relativePeriod?: RelativePeriod;
}

export type DateSelection = DateParameter | RelativeDate;

export interface FeatureDetailType {
  name: string;
  displayName: string;
  type: string;
  isDefaultColumn?: boolean;
  dataValues?: object[];
  multiSelect?: boolean;
}

export interface DateRange {
  dateOperator: DateOperator;
  date: DateSelection;
  rangeDateOperator?: DateOperator;
  rangeDate?: DateSelection;
  dateField?: FeatureDetailType;
}

export interface AgeRange {
  /**
   * Value of the date
   */
  value: DateRange;
}

export interface DropDownSource {
  /**
   * Text of the dropdown
   */
  text: string;
  /**
   * Value of the dropdown
   */
  value: string;
}

export interface AgeValueRange {
  /**
   * Date range
   */
  dateRange: DateRange;
  /**
   * Age value comparator (All comparision operators)
   */
  operator: ListType;
  /**
   * Age value
   */
  value: string;
  /**
   * Age value type (Days/ Weeks/ Months/ Years)
   */
  valueUnit: ListType;
}

export interface AgeRangeType {
  /**
   * Value of the age
   */
  data: AgeValueRange;
  /**
   * Flag for valid feature
   */
  isValid: boolean;
}

export enum AgeTypes {
  DATE = "date",
  AGE = "age",
  NONE = "none"
}
